<template>
  <div class="consult">
    <drug-guide title="咨询互动" :headimg="conHead" :enimg="enImg"></drug-guide>
    <div class="consult-con">
      <img :src="bgImg" alt="">
      <div class="consult-top">
        <div class="consult-left">
          <div class="consult-desc">
            <div class="consult-title">联系我们</div>
            <div class="consult-en">CONTACT US</div>
            <div class="consult-phone">电话：{{ consult.phone }}</div>
<!--            <div class="consult-email">邮箱：{{ consult.email }}</div>-->
            <div class="consult-address">地址：{{ consult.address }}</div>
          </div>
          <div class="consult-code">
            <div>官方客服微信</div>
            <img :src="codeImg" alt="">
          </div>
        </div>
        <div class="consult-map">
          <img :src="mapImg" alt="">
        </div>
      </div>
    </div>
    <drug-footer></drug-footer>
  </div>
</template>

<script>
import DrugFooter from "../../components/DrugFooter";
import DrugGuide from "../../components/DrugGuide";
export default {
  name: "Consult",
  components: {
    DrugFooter,
    DrugGuide
  },
  data() {
    return {
      conHead: "static/images/consult/con-head.png",
      enImg: "static/images/consult/con-en.png",
      codeImg: "static/images/consult/con-code.png",
      mapImg: "static/images/consult/con-map.png",
      bgImg: "static/images/consult/con-bg.png",
      consult: {
        phone: "0851-84600262",
        email: "hanfang@ggguuu.com",
        address: "贵州省贵阳市贵阳国家高新技术产业开发区沙文镇创纬路118号"
      }
    }
  },
  mounted() {
    this.$store.commit("getactive", 6);
  }
}
</script>

<style lang="scss" scoped>
.consult {
  .consult-con {
    width: 80%;
    height: 490px;
    overflow: hidden;
    margin: 30px auto 0 auto;
    background-color: #fff;
    position: relative;
    padding: 40px 20px;
    box-sizing: border-box;
    &>img {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      z-index: 10;
    }
    .consult-top {
      width: 100%;
      height: 350px;
      display: flex;
      justify-content: space-between;
      position: relative;
      z-index: 20;
      .consult-left {
        width: 45%;
        height: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .consult-desc {
          .consult-title {
            height: 50px;
            line-height: 50px;
            font-size: 36px;
            font-family: "PingFang SC-Medium", "PingFang SC";
            font-weight: 500;
            color: #002244;
          }
          .consult-en {
            font-size: 18px;
            font-family: "Roboto-Italic", "Roboto";
            color: #4392EC;
            letter-spacing: 2px;
            font-style: italic;
            margin-bottom: 40px;
          }
          .consult-phone, .consult-email, .consult-address {
            font-size: 16px;
            font-weight: 400;
            color: #002244;
            line-height: 35px;
          }
        }
        .consult-code {
          width: 150px;
          height: 180px;
          background: #4392EC;
          font-size: 16px;
          color: #fff;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-around;
          img {
            width: 138px;
            height: 138px;
          }
        }
      }
      .consult-map {
        width: 50%;
        height: 100%;
        display: flex;
        align-items: center;
        img {
          width: 100%;
          // height: 100%;
          display: block;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/consult/consult.vue